import "./Modal.scss";
import ModalFooter from "./ModalFooter";
import ModalHeader from "./ModalHeader";
import ReactDom from "react-dom";
import { useEffect } from "react";
import { MODAL_CONTENT, QUERY_STATUS } from "constants/constants";
import Proptypes from "prop-types";

const Modal = ({
  open,
  onClose,
  onValidate,
  title,
  icon,
  children,
  modalType,
  cancelButton = "cancel",
  validButton = "validate",
  entityStatus,
}) => {
  useEffect(() => {
    if (!open) return;
    const handleKeyDown = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [open, onClose]);

  const ENTITY_MODALS = [
    MODAL_CONTENT.MANAGE_DAILY_FEE,
    MODAL_CONTENT.MANAGE_WORK_CONTRACT,
    MODAL_CONTENT.MANAGE_JOB_HISTORY,
    MODAL_CONTENT.MANAGE_HISTORY_MANAGERS,
    MODAL_CONTENT.MANAGE_EXTERNAL_TRAINING,
    MODAL_CONTENT.MANAGE_POSITION_COEF,
    MODAL_CONTENT.MANAGE_COMPANY_HISTORY,
    MODAL_CONTENT.MANAGE_SALARY,
  ];
  const isEntityModal = ENTITY_MODALS.includes(modalType);

  if (!open) return null;
  return ReactDom.createPortal(
    <>
      <div className="overlay-style" />
      <div className="modal-style">
        <ModalHeader
          onClose={onClose}
          title={title}
          icon={icon}
          modalType={modalType}
        />
        <div className={`modal_body ${isEntityModal ? "modal_body--entity" : ""}`}>
          {children}
          <br /> <br />
          {modalType !== MODAL_CONTENT.MANAGE_DAILY_FEE &&
            modalType !== MODAL_CONTENT.MANAGE_WORK_CONTRACT &&
            modalType !== MODAL_CONTENT.MANAGE_JOB_HISTORY &&
            modalType !== MODAL_CONTENT.MANAGE_HISTORY_MANAGERS &&
            modalType !== MODAL_CONTENT.MANAGE_EXTERNAL_TRAINING &&
            modalType !== MODAL_CONTENT.MANAGE_POSITION_COEF &&
            modalType !== MODAL_CONTENT.MANAGE_COMPANY_HISTORY &&
            modalType !== MODAL_CONTENT.MANAGE_SALARY && (
              <ModalFooter
                onClose={onClose}
                onValidate={onValidate}
                modalType={modalType}
                cancelButton={cancelButton}
                validButton={validButton}
                disabled={entityStatus === QUERY_STATUS.LOADING}
              />
            )}
        </div>
      </div>
    </>,
    document.getElementById("portal")
  );
};

export default Modal;

Modal.propTypes = {
  open: Proptypes.bool,
  onClose: Proptypes.func,
  onValidate: Proptypes.func,
  title: Proptypes.object,
  icon: Proptypes.string,
  children: Proptypes.array,
  modalType: Proptypes.object,
};
